import * as yup from 'yup'
import { WebhookEventType, WebhookVersion } from 'src/constants/webhook/enums'

/**
 * Mirrors the two backend validators that would otherwise answer with an opaque 400:
 * `@IsUrl()` on `callbackUrl` and `@IsArray @ArrayNotEmpty @IsEnum(WebhookEventType, { each: true })`
 * on `events`. The enum check is included so an event value that is not on the backend can never
 * be submitted from here.
 */
export const webhookSubscriptionFormValidator = yup.object({
  callbackUrl: yup
    .string()
    .trim()
    .required('Callback URL is required')
    .url('Enter a valid URL, including https://'),
  events: yup
    .array()
    .of(yup.mixed<WebhookEventType>().oneOf(Object.values(WebhookEventType)).required())
    .min(1, 'Choose at least one event')
    .required('Choose at least one event'),
  webhookVersion: yup
    .mixed<WebhookVersion>()
    .oneOf(Object.values(WebhookVersion))
    .required('Version is required'),
})
